import { ENVIRONMENT_INITIALIZER, inject } from '@angular/core';
import { CasdoorAuthService } from 'app/core/auth/casdoor-auth.service';
import { filter, take } from 'rxjs';
import { FCMService } from './fcm.service';

/**
 * Provider function for FCM service initialization
 * Waits for user authentication before initializing FCM
 * This ensures the auth token is available when registering the device token with the backend
 *
 * @returns Array of providers for dependency injection
 */
export function provideFCM() {
    return [
        {
            provide: ENVIRONMENT_INITIALIZER,
            useValue: () => {
                const fcmService = inject(FCMService);
                const authService = inject(CasdoorAuthService);

                // Wait for authentication before initializing FCM
                // This ensures we have a valid auth token when sending the device token to backend
                authService.isAuthenticated$
                    .pipe(
                        filter(isAuthenticated => isAuthenticated === true),
                        take(1)
                    )
                    .subscribe(() => {
                        console.log('[FCM Provider] User authenticated, initializing FCM...');
                        // Small delay to ensure auth is fully settled
                        setTimeout(() => {
                            fcmService.initializeFCM().catch((error) => {
                                console.error('[FCM Provider] Initialization failed:', error);
                            });
                        }, 1000);
                    });
            },
            multi: true,
        },
    ];
}
